import Image from "next/image";
import { cn } from "@/lib/utils";

export function LogoMark({ className }: { className?: string }) {
  return (
    <Image
      src="/brand/snopdesk-mark.png"
      alt=""
      width={64}
      height={64}
      priority
      className={cn("size-8 shrink-0 object-contain", className)}
      aria-hidden="true"
    />
  );
}

export function Logo({
  className,
  variant = "auto",
}: {
  className?: string;
  /**
   * "auto" swaps for the current light/dark theme. "onDark" pins the
   * white-text logo for surfaces that are always dark (e.g. the auth
   * panel's navy gradient), independent of the site theme.
   */
  variant?: "auto" | "onDark";
}) {
  const imageClassName = cn("h-11 w-auto object-contain", className);

  if (variant === "onDark") {
    return (
      <Image
        src="/brand/snopdesk-logo.png"
        alt="SnopDesk"
        width={2172}
        height={724}
        priority
        className={imageClassName}
      />
    );
  }

  return (
    <>
      <Image
        src="/brand/snopdesk-logo-dark.png"
        alt="SnopDesk"
        width={2172}
        height={724}
        priority
        className={cn(imageClassName, "dark:hidden")}
      />
      <Image
        src="/brand/snopdesk-logo.png"
        alt="SnopDesk"
        width={2172}
        height={724}
        priority
        className={cn(imageClassName, "hidden dark:block")}
      />
    </>
  );
}
